import React from 'react';
import { Col } from 'react-bootstrap';
import { FilePond } from "react-filepond";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

const FileField = ({ label, name, formik, file, onUpdateFiles, colSize, helperText = '' }) => {
  return (
    <Col lg={colSize}>
        <div className='text-center'>
            <label htmlFor={name} className="form-label text-center">
                {label} <p className="text-muted text-center">{helperText}</p>
            </label>
        </div>
        <FilePond
            file={file}
            onupdatefiles={onUpdateFiles}
            allowMultiple={false}
            maxFiles={1}
            name={name}
            labelIdle='<span class="filepond--label-action">Parcourir</span> ou Glisser directement'
        />
        {formik.touched[name] && formik.errors[name] && (
            <div className="text-danger">{formik.errors[name]}</div>
        )}
    </Col>
  );
};

export default FileField;
